<div class="mt-1">
    <button mat-icon-button [matMenuTriggerFor]="languages">
        <mat-icon>translate</mat-icon>
    </button>

    <!-- Language menu -->
    <mat-menu [xPosition]="'before'" #languages="matMenu">
        <span class="mx-4 text-xs font-bold uppercase text-primary">{{
            'navigation.Choose Your App Language' | translate
        }}</span>
        @for (item of languagesArray; track item._id) {
            <button mat-menu-item (click)="onLanguageChange(item)">
                <span class="flex items-center">
                    <span class="mx-2"
                        >{{ item.name }}
                        @if (getNativeName(item.default)) {
                            <span class="text-gray-500"
                                >({{ getNativeName(item.default) }})</span
                            >
                        }
                    </span>
                    @if (item.default === selectedLanguage) {
                        <mat-icon class="text-primary">check</mat-icon>
                    }
                </span>
            </button>
        }
    </mat-menu>
</div>
